import { defineMessage } from 'services/localization';

export const messages = {
    overOrEqualTo: defineMessage('over_or_equal_to'),
    between: defineMessage('between'),
    under: defineMessage('under'),
    anyAmount: defineMessage('any_amount'),
    changeTheAmountRule: defineMessage('change_the_amount_rule'),
    overOrEqualToGv: defineMessage('over_or_equal_to_gv'),
    underLv: defineMessage('under_lv'),
    betweenGvLv: defineMessage('between_gvlv'),
    notSet: defineMessage('not_set'),
    enterValue: defineMessage('enter_value'),
};
